export const FOOTER_TEXTS = {
    PAYMENT_DONE: "Done",
    PAYMENT_NEED_HELP: "Need help with this order?",
    PAYMENT_VIEW_HELP: "HELP",
};
